import { useEffect, useRef } from 'react';
// import { twMerge } from 'tailwind-merge';
import Page from '../components/containers/Page';
import { NavLink, /* useNavigate, */ useParams } from 'react-router-dom';
import ImageMedia from '../components/common/ImageMedia';
import useLink from '../hooks/useLink';
// import useProjectPrev from '../hooks/useProjectPrev';
import useMouse from '../hooks/useMouse';
import { Section } from '../components/imports';
import { project } from '../data/data';
import { LetsWork } from './Home';
import { motion } from 'framer-motion';
import animA from '../animations/animA';
import MoveAround from '../components/containers/MoveAround';
import { log as logs } from '../data/logs';
// import DynamicLogLoader from '../logs/DynamicLogLoader';

const Work = () => {

  const { logId } = useParams();
  // const navigate = useNavigate();
  const prLink = useLink();

 /*  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate("/log");
    }
  }; */

  const currentIndex = logs.findIndex(pr => prLink(pr.company) === logId);
  const thisLog = logs.find(log => prLink(log.company) === logId);

  const nextLog = currentIndex < logs.length ? logs[currentIndex + 1] : null;
  // const prevLog = currentIndex > 0 ? logs[currentIndex - 1] : null;

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" })
  }, [])

  // PAGE TITLE
  document.title = `LOG • ${String(thisLog.company).toUpperCase()} — ${project.website} `


  /* 
    const nextProjects = [
      projects[currentIndex - 1], // Project at currentIndex - 1
      projects[currentIndex + 1], // Project at currentIndex + 1
      projects[currentIndex + 2],  // Project at currentIndex + 2
      projects[currentIndex + 3]  // Project at currentIndex + 2
    ].filter(project => project !== undefined); // Filter out any undefined values
   */


  /*   useEffect(() => {
      console.log(logId, currentIndex);
      console.log("More Projects", nextProjects);
    }, [logId, currentIndex, nextProjects]); */


  // NEXT PROJECT ANIMATION
  const nextRef = useRef(null);

  /*  const { scrollYProgress } = useScroll({
    target: nextRef,
    offset: ["center end", "center start"]
  }) */

  // const marginValue = 160;
  // const triggerPoint = .5
  // const marginBottom = useTransform(scrollYProgress, [0, 1], [marginValue * 3, -marginValue * 2])
  // const cardOpacity = useTransform(scrollYProgress, [triggerPoint, 1], [1, .7]);
  // const cardScale = useTransform(scrollYProgress, [triggerPoint, 1], [1, .5]);

  return (

    thisLog &&

    <Page>
      <Section padded center>
        <div className='max-w-96'>
          <MoveAround style={{ filter: "sharpness-[2]" }} className='relative flex center aspect-[4/5] max-h-[80vh]'>
            {/* <DefaultContent /> */}
            <ImageMedia bypass src={require(`../assets/log/log - ${prLink(thisLog.company)}.jpg`)} className="dim==========hover:!nodim hover:unmute pointer-events-auto select-none cursor-default muted md:scale-[103%] oneSecond object-cover full" />
          </MoveAround>
        </div>
      </Section>

      <div className='flex flex-col absolute full bottom-0 py-20 items-end justify-end inset-0 bg-gradient-to-t from-black/90 via-transparent bg-blend-multiply pointer-events-none'>
        <div className='resp flex flex-col lg:items-start justify-between'>
          <div className='flex'>
            <h1 style={{ fontWeight: "450" }} className='capitalize !leading-none tracking-tight drop-shadow-2xl !font-maison'>{thisLog.company}</h1>
          </div>
        </div>


        {/* NAVIGATE PREV & NEXT PROJECT */}
        {/* {prevProject &&
          <div className='absolute left-0 inset-y-0 bg-white/0 max-lg:portrait:active:bg-white/10 lg:landscape:hover:bg-white/10 w-[50px] md:w-[5vw] cursor-pointer transition group quick'>
            <NavLink to={`/work/${prLink(prevProject.client)}`} className='relative full flex center '>
              <i className='bg-white/20 group-hover:bg-white/0 aspect-square  flex center size-10 rounded-full text-white mix-blend-exclusion  ri-xl ri-arrow-left-s-line ' />
            </NavLink>
          </div>}

        {nextProject &&
          <div className='absolute right-0 inset-y-0 bg-white/0 max-lg:portrait:active:bg-white/10  lg:landscape:hover:bg-white/10 w-[50px] md:w-[5vw] cursor-pointer transition group quick'>
            <NavLink to={`/work/${prLink(nextProject.client)}`} className='relative full flex center '>
              <i className='bg-white/20 group-hover:bg-white/0 aspect-square  flex center size-10 rounded-full text-white mix-blend-exclusion ri-xl ri-arrow-right-s-line ' />
            </NavLink>
          </div>} */}

      </div>


      {/* DYNAMICALLY IMPORTED PROJECT DATA */}
      {/* <DynamicLogLoader /> */}

      <div ref={nextRef} className='relative flex flex-col items-center justify-start w-full overflow-y-clip '>
        <div className='bg-gradient-to-t from-neutral-950 to-dark h-[120%] absolute bottom-0 z-[0]  inset-x-0' />

        {nextLog &&
          <NextProject
            nextProject={nextLog}
          />
        }

      </div>

      {
        !nextLog &&

        <>
          {/* <OtherProjects thisLog={thisLog} /> */}
          <div className='flex h-[30vh]' />
          <LetsWork />
        </>
      }


    </Page >

  )
}

const NextProject = ({ nextProject, marginBottom, cardOpacity /* , cardScale */ }) => {
  const prLink = useLink()
  const { toDefault, toSee } = useMouse();
  const { ease, duration } = animA();

  return (
    <motion.div
      style={{
        marginBottom,
        opacity: cardOpacity,
        // scale: cardScale
      }}
      // whileHover={{opacity: .6}}
      transition={{ ease, duration }}
      className='resp flex !h-[70%] min-h-[500px] mx-auto my-40 bg-dark border border1 z-[2] w-[85%] md:aspect-video relative group scale-[97%] hover:scale-[105%] max-md:rounded-xl quick overflow-clip'>


      <NavLink to={`/log/${prLink(nextProject.company)}`} onMouseEnter={toSee} onMouseLeave={toDefault} className='relative= flex full overflow-y-clip'>
        <div className='bg-gradient-to-b from-dark/50 absolute top-0 inset-x-0 h-[30%] scale-110 !z-[1]' />
        <ImageMedia /* bypass */
          src={require(`../assets/log/${prLink(nextProject.company)}.jpg`)}
          className={`${nextProject.metadata.css} absolute pointer-events-none select-none inset-0 full scale-[102%] group-hover:nodim group-hover:unmute group-hover:scale-[105%] quick`}
        />
        <div className='resp relative paddingY !z-[2]'>
          <div className="relative flex flex-col items-start w-fit">
            <h5 className='font-light uppercase text-white'>Voir projet suivant</h5>
            {/* <i className='z-[2] group-hover:translate-x-[25%] oneSecond my-auto absolute -right-4 ri-xl ri-arrow-down-s-line' /> */}
            {/* &nbsp;|&nbsp;  */}
            <h1 className='flex capitalize max-w-[15ch] font-medium leading-none tracking-tight origin-top-left scale-90 group-hover:scale-100= quick'>{nextProject.company}</h1>
          </div>
        </div>
      </NavLink>
    </motion.div>
  )
}



export default Work
